module.exports = __webpack_public_path__ + "img/a1e4118.png";